/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Bar from "../../Charts/Bar";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { ExportChartWrapper } from "../styles/spend-per-sector-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";

export interface ISpendPerSectorPdfExportProps {
  currencySymbol?: string;
  spendPerSectorPdfExport: {
    sectors?: Array<string>;
    values?: Array<number>;
  };
  spendPerSectorWidgetLoader: boolean;
}

export class SpendPerSectorPdfExport extends Component<
  ISpendPerSectorPdfExportProps,
  unknown
> {
  static propTypes = {
    currencySymbol: PropTypes.string.isRequired,
    spendPerSectorPdfExport: PropTypes.shape({
      sectors: PropTypes.arrayOf(PropTypes.string),
      values: PropTypes.arrayOf(PropTypes.number),
    }).isRequired,
    spendPerSectorWidgetLoader: PropTypes.bool.isRequired,
  };

  state = {};

  render(): ReactNode {
    const {
      currencySymbol,
      spendPerSectorPdfExport,
      spendPerSectorWidgetLoader,
    } = this.props;

    const spendPerSectorPdfExportOptions = {
      series: [
        {
          data: spendPerSectorPdfExport.values,
        },
      ],
      options: {
        colors: ["#00e396"],
        chart: {
          toolbar: {
            show: false,
          },
          height: "100%",
        },
        dataLabels: {
          enabled: true,
          formatter: (val: number) => val,
          offsetX: 20,
          offsetY: 0,
          style: {
            fontSize: "11px",
            colors: ["#333"],
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 1,
                  color: "red",
                },
              ],
            },
            dataLabels: {
              position: "right",
            },
          },
        },
        xaxis: {
          categories: spendPerSectorPdfExport.sectors,
        },
      },
    };

    return (
      <Fragment>
        <ExportChartWrapper>
          <AnalyticsWidgetLoading
            text="Updating..."
            active={spendPerSectorWidgetLoader}
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="spend-per-sector-chart-title"
          >
            {`Spend per Sector (${currencySymbol})`}
          </ChartTitle>
          <Bar
            height={270}
            width={450}
            graphOptions={spendPerSectorPdfExportOptions}
            dataTestId="spend-per-sector-chart"
          />
        </ExportChartWrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    currencySymbol?: string;
    chartsData: {
      spendPerSector: unknown;
    };
    spendPerSectorWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  currencySymbol: state.employerAnalytics.currencySymbol,
  spendPerSectorPdfExport: state.employerAnalytics.chartsData.spendPerSector,
  spendPerSectorWidgetLoader:
    state.employerAnalytics.spendPerSectorWidgetLoader,
});

export default connect(mapStateToProps, {})(SpendPerSectorPdfExport);
